import { Component } from '@angular/core';
import { NavController, NavParams, Events, ViewController, PopoverController} from 'ionic-angular';
import { HttpProvider } from '../../providers/http/http';
import { trigger, transition, useAnimation, state, style } from '@angular/animations';
import { tada } from 'ng-animate';
import { MonedaPage } from '../moneda/moneda';

/**
 * Generated class for the Detalle2Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-detalle2',
  templateUrl: 'detalle2.html',
  animations:[
    trigger('car',[
      state('open',style({
        backgroundColor:'transparent' 
      })),
      state('close',style({
        backgroundColor:'transparent' 
      })),
      transition('open=>close',useAnimation(tada,{
        params:{
          timing:2
        }
      })),
      transition('close=>open',useAnimation(tada,{
        params:{
          timing:2
        }
      }))
    ])
  ]
})
export class Detalle2Page {
  pedido:any = {}
  path:any = this.https.images
  codigo: any = ''
  moneda: any = 'USD'
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public popCtrl: PopoverController,
    public https: HttpProvider,
    public events : Events,
    public viewCtrl : ViewController,
    ) {
      events.subscribe('moneda:update', ()=>{
        this.updateMoneda()
      })
      if(window.localStorage.moneda){
        this.moneda = window.localStorage.moneda
      }
      this.pedido = this.navParams.get('pedido')
  }

  ionViewDidLoad() {
  }

  updateMoneda(){
    if(window.localStorage.moneda){
      this.moneda = window.localStorage.moneda
    }
  }

  calcCantidad(item) {
    let cont = 0
    for (let i = 0; i < item.length; i++) {
      cont += item[i].cant
    }
    return cont
  }

  showMonedas(){
    const pop = this.popCtrl.create(MonedaPage, {}, {cssClass: 'popppover'})
    pop.present()
  }

  transform(value) {
    if(value){
      let val
      val = parseFloat(value)
      val = parseFloat(val).toFixed(2)
      val = val.toString().split('.')
      if(val.length > 1) return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + ','+ val[1].slice(0,2);
      return val[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
    }else{
      return value
    }
  }

  buscarMetodo(item) {
    let cond = JSON.parse(window.localStorage.getItem('condiciones'))
    let result = ''
    if (cond && cond.length > 0) {
      cond.forEach(el=>{
        if (item.trim() === el.co_cond.trim()) {
          result = el.cond_des.trim()
        }
      })
    }
    return result
  }

  printEstatus(status){
    if(status){
      status = status.replace(' ','')
      switch(status){
        case '0':return 'Creado'
        case '1':return 'Parcial'
        case '2':return 'Procesado'
        case '3':return 'Sin enviar'
      }
    }
  }

  close(){
    this.viewCtrl.dismiss()
  }

}



// WEBPACK FOOTER //
// ./src/pages/detalle2/detalle2.ts